import { defineMessages } from 'react-intl';

/** Plan names on the ended modal's plan switcher and buttons. */
export const complimentaryEndedPlanMessages = defineMessages({
  clinician: {
    defaultMessage: 'Clinician',
    id: 'uYaOjvYBeO',
    description:
      'Plan switcher tab in the complimentary usage ended modal for the Clinician seat',
  },
  max: {
    defaultMessage: 'Max',
    id: '06yzQZwuZe',
    description:
      'Plan switcher tab in the complimentary usage ended modal for the Clinician Max seat',
  },
  free: {
    defaultMessage: 'Free',
    id: 'XSWMHXPy4x',
    description:
      'Plan switcher tab in the complimentary usage ended modal for Heidi Free',
  },
  scribePlus: {
    defaultMessage: 'Scribe Plus',
    id: 'AVgiieiJiz',
    description:
      'Plan switcher tab in the complimentary usage ended modal for Scribe Plus',
  },
  recommended: {
    defaultMessage: 'Recommended',
    id: '7xwQZGdce8',
    description: 'Badge on the plan the complimentary usage ended modal recommends',
  },
  current: {
    defaultMessage: 'Current',
    id: '8hPeBT2ioL',
    description:
      'Badge on the member’s current plan in the complimentary usage ended modal',
  },
  stayOn: {
    defaultMessage: 'Stay on {planName}',
    id: 'ynATlxpMof',
    description:
      'Button in the complimentary usage ended modal that keeps the member on their current plan',
  },
  footnote: {
    defaultMessage:
      'If you stay on your current plan, billing is unchanged and you still have full access to Scribe.',
    id: 'BDt+vggztK',
    description: 'Footnote in the complimentary usage ended modal',
  },
  stayToast: {
    defaultMessage: 'You’re still on your current plan, {planName}.',
    id: 'JAMfLgsFua',
    description:
      'Toast after the member stays on or closes the complimentary usage ended modal; planName is their plan',
  },
  featureInfo: {
    defaultMessage: 'About {feature}',
    id: 'iZD+mwZRan',
    description:
      'Accessible label of the info button next to a plan feature in the complimentary usage ended modal',
  },
});

export const complimentaryEndedCopyMessages = defineMessages({
  titleExceeded: {
    defaultMessage: 'You exceeded your plan’s agentic usage limit.',
    id: 'WOwVo9gKFD',
    description: 'Complimentary usage ended modal title once usage needs Clinician Max',
  },
  bodyLight: {
    defaultMessage:
      'You can continue using Heidi as you are. For more agentic usage, upgrade your plan.',
    id: 'y1aiiOI955',
    description: 'Complimentary usage ended modal body for light usage',
  },
  bodyNearLimit: {
    defaultMessage:
      'You used most of your limit during the complimentary period. For more usage, upgrade now.',
    id: 'hs+pWMVXKI',
    description: 'Complimentary usage ended modal body for members near their limit',
  },
  bodyBestMax: {
    defaultMessage:
      'The complimentary period is over. Based on your usage the best plan for you is Clinician Max.',
    id: '2AVB8TEO2G',
    description: 'Complimentary usage ended modal body once usage needs Clinician Max',
  },
  titleEnded: {
    defaultMessage: 'Your complimentary agentic usage has ended',
    id: '6f3caWotF+',
    description: 'Complimentary usage ended modal title for light usage',
  },
  upgradeToClinician: {
    defaultMessage: 'Upgrade to Clinician',
    id: 'PEMXA/yDAR',
    description:
      'Upgrade button in the complimentary usage ended modal; opens the Standard seat checkout',
  },
  upgradeToClinicianMax: {
    defaultMessage: 'Upgrade to Clinician Max',
    id: '8jESf22ogW',
    description:
      'Upgrade button in the complimentary usage ended modal; opens the Max seat checkout',
  },
});

export const complimentaryEndedFeatureMessages = defineMessages({
  freeForever: {
    defaultMessage: 'Free forever',
    id: 'Ys6nYPoNXZ',
    description:
      'Heading over the Free plan features in the complimentary usage ended modal',
  },
  everythingInFree: {
    defaultMessage: 'Everything in Free, plus:',
    id: 'hthl0rZfR6',
    description:
      'Heading over a plan’s features beyond Free in the complimentary usage ended modal',
  },
  everythingInScribePlus: {
    defaultMessage: 'Everything in Scribe Plus, plus:',
    id: '2KJw0Qn9/Y',
    description:
      'Heading over a plan’s features beyond Scribe Plus in the complimentary usage ended modal',
  },
  everythingInClinicianStandard: {
    defaultMessage: 'Everything in Clinician Standard, plus:',
    id: 'QXKXt9myGz',
    description:
      'Heading over Clinician Max features beyond Clinician Standard in the complimentary usage ended modal',
  },
  unlimitedScribeNotes: {
    defaultMessage: 'Unlimited Scribe notes',
    id: 'OZqz8By65e',
    description: 'Free plan feature in the complimentary usage ended modal',
  },
  unlimitedScribeNotesTip: {
    defaultMessage: 'Turn patient conversations into text with no usage caps.',
    id: 'MLDpu4OrX7',
    description: 'Tooltip for the unlimited Scribe notes feature',
  },
  limitedAgentUse: {
    defaultMessage: 'Limited usage for agents',
    id: 'DHXD3HfefA',
    description: 'Free plan feature in the complimentary usage ended modal',
  },
  limitedAdvancedTemplates: {
    defaultMessage: 'Limited use of advanced templates',
    id: '15Pz+p1G1m',
    description: 'Free plan feature in the complimentary usage ended modal',
  },
  advancedTemplatesTip: {
    defaultMessage: 'Use more detailed, specialty-specific note templates.',
    id: 'nr0Cl9E+C4',
    description:
      'Tooltip for advanced template use in the complimentary usage ended modal',
  },
  handHeidiATaskTip: {
    defaultMessage: 'Hand Heidi a task in plain language and review what it hands back.',
    id: 'wIYH6U2nlf',
    description: 'Tooltip for limited agent usage in the complimentary usage ended modal',
  },
  unlimitedTemplates: {
    defaultMessage: 'Unlimited advanced templates',
    id: 'OoEOgRn8BY',
    description: 'Plan feature in the complimentary usage ended modal',
  },
  evidenceInPatientVisits: {
    defaultMessage: 'Evidence in patient visits',
    id: 'hi7ZfnD0xm',
    description:
      'Clinician plan feature compared with Free in the complimentary usage ended modal',
  },
  evidenceInPatientVisitsTip: {
    defaultMessage: 'Access evidence while reviewing or discussing patient cases.',
    id: '4WVBhKvRY6',
    description:
      'Tooltip for Evidence in patient visits in the complimentary usage ended modal',
  },
  dailyAgenticUseTip: {
    defaultMessage: 'Run tasks and routines every day of the week.',
    id: 'fMznFVDI7D',
    description: 'Tooltip for the daily agentic workflows feature',
  },
  dailyAgentsAndRoutines: {
    defaultMessage: 'Usage for daily agents and routines',
    id: 'KpettVaRYI',
    description:
      'Clinician Max feature compared with Free in the complimentary usage ended modal',
  },
  limitedInSessionEvidence: {
    defaultMessage: 'Limited Evidence in visits',
    id: 'Q3YA3nnL4s',
    description: 'Scribe Plus plan feature in the complimentary usage ended modal',
  },
  limitedInSessionEvidenceTip: {
    defaultMessage: 'Evidence in patient visits, up to your plan limit.',
    id: 'JNioCMzkqf',
    description: 'Tooltip for the limited Evidence in visits feature',
  },
  moreAgentUsage: {
    defaultMessage: 'More usage for agents',
    id: 'lza59r6CiF',
    description:
      'Clinician plan feature compared with Scribe Plus in the complimentary usage ended modal',
  },
  moreAgentUsageTip: {
    defaultMessage: 'Hand Heidi tasks and routines.',
    id: 'OhFoofTJS/',
    description: 'Tooltip for the more agent usage feature',
  },
  premiumEvidenceSources: {
    defaultMessage: 'Premium evidence sources',
    id: 'ttttLfE8MM',
    description:
      'Premium evidence sources feature in the complimentary usage ended modal',
  },
  premiumEvidenceSourcesTip: {
    defaultMessage: 'Access a broader range of high-quality evidence sources.',
    id: 'rGNwVVbBop',
    description: 'Tooltip for the premium evidence sources feature',
  },
  earlyAccess: {
    defaultMessage: 'Early access to advanced features',
    id: 'Y9MzdZ1MJ9',
    description:
      'Clinician Max feature compared with Clinician Standard in the complimentary usage ended modal',
  },
  earlyAccessTip: {
    defaultMessage: 'Try new Heidi features before they reach other plans.',
    id: 'aj6K2pFc1X',
    description: 'Tooltip for the early access feature',
  },
});
